<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.titleBox') }}
    </c-label>
    <BoxRegion class="mt-24" />
    <div class="content-wrapper">
      <ConfigTitle required class="title">{{ $util.capitalize($t('label.title')) }}</ConfigTitle>
      <div class="dom">
        <c-scroll class="cscroll">
          <div v-for="(text, index) in texts" :key="index" style="display: flex">
            <lego-text-field
              ref="text"
              :modelValue="texts[index]"
              :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
              :rules="validator.text"
              :counter="100"
              @update:modelValue="(value) => changeTitleBox(value, index)"
              showCounter
              isFreeText
            />
            <lego-icon-button
              v-if="texts.length > 1"
              style="margin-left: 8px"
              icon="delete"
              iconType="picto"
              :iconColor="$theme.COLOR.UI.UI01"
              @click="removeText(index)"
            />
          </div>
        </c-scroll>
      </div>
      <div v-if="isAddMode" class="textBtn" @click="addTextBox">
        + {{ $util.capitalize($t('label.add')) }}
      </div>
    </div>
  </div>
</template>
<script>
import configMixin from './configMixin';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  props: {},
  mixins: [configMixin, validateFieldsMixin],
  emits: ['configModify', 'update:changeField'],
  data() {
    return {
      // 타이틀s
      isChanged: false,
      texts: [],
      validator: {
        text: [this.checkText]
      },
      // 타이틀 박스 기본 설정 정보
      defaultConfig: this.config({
        isResizable: true,
        h: 2,
        minW: 1,
        maxW: 8,
        minH: 1,
        maxH: 6,
        widget: { api: '', type: 'TitleBoxWidget', options: {} }
      }),
      validateFieldKey: 'titleBoxWidgetConfig'
    };
  },
  watch: {
    texts: {
      deep: true,
      handler() {
        this.validateBtnComfirm();
        this.onConfigChange();
      }
    },
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  mounted() {
    this.setFieldsBeforeModify();
  },
  methods: {
    changeData() {
      this.isChanged = true;
    },
    validateBtnComfirm() {
      const check = this.texts.some((text) => {
        return typeof this.checkText(text) === 'string';
      });
      this.$emit('changeValidate', check);
    },
    // validation check
    checkText(value) {
      if (!this.checkEmpty(value)) {
        return this.$t('message.requiredInput'); // '타이틀을 입력하세요.';
      }
      if (value.length > 100) {
        return this.$t('message.inputLimit', [this.$t('label.title'), '100']); //'타이틀은 최대 50자까지 입력이 가능합니다.';
      }
      if (value.charAt(0) === '.') {
        return this.$t('message.errorValidateInput');
      }
      if (this.$util.requireInputCommon(value)) {
        return this.$t('message.errorValidateInput');
      }
      return true;
    },
    validate() {
      return this.$util.validate(this.$refs.text);
    },
    // 위젯 설정 정보 셋팅
    setDefault() {
      const chartAttr = this.defaultConfig.chartAttr;
      this.texts.push(chartAttr.title);
    },

    // 설정정보 update
    onConfigChange() {
      let configs = [];
      for (let i in this.texts) {
        let config = this.$util.deepCopy(this.defaultConfig);
        config.chartAttr.title = this.texts[i].slice(0, 100);
        config.isAccountAuth = true;
        configs.push(config);
      }
      this.checkCount++;
      if (this.checkCount === 1) this.originConfigs = configs;

      this.$emit('configModify', configs);
    },

    // 타이틀 박스 추가
    addTextBox() {
      this.changeData();
      this.texts.push('');
    },

    // 타이틀 박스 제거
    removeText(index) {
      this.texts.splice(index, 1);
    },

    changeTitleBox(value, index) {
      if (value !== this.texts[index]) {
        this.changeData();
        this.texts[index] = value;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.textBtn {
  color: #364fc7;
  cursor: pointer;
  user-select: none;
  margin-top: 24px;
  width: fit-content;
}

.content-wrapper {
  margin-top: 24px;

  .dom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .cscroll {
      max-height: 510px;
      margin-right: -16px;
      padding-right: 16px;
    }
  }
}
</style>
